/**
 * PageHeader Component
 */

import { baseline } from '../../../styles/grid';
import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { Helmet } from 'react-helmet';

import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import CurrencySelect from '../../forms/Select/CurrencySelect';

interface IOwnProps {
  className?: string;
  actions?: React.ReactNode;
  title?: string;
  withCurrencySelect?: boolean;
}

export type PageHeaderProps = IOwnProps;

const classes = new BEM('page__header');

export default class PageHeader extends React.Component<IOwnProps, any> {

  render() {
    return (
      <>
        <div {...classes('fixed-guard')} />
        <header {...classes('', '', this.props.className) }>
          <Helmet>
            <title>{this.props.title}</title>
          </Helmet>
          {this.props.children || (
            <div {...classes('content') }>
              {this.props.title && (<>
                <div {...classes('title__dash') } />
                <Heading is="h4" {...classes('title') }>{this.props.title}</Heading>
              </>)}
              <div {...classes('actions')}>
                {this.props.actions}
                {this.props.withCurrencySelect && (<>
                  <Span
                    size="small"
                    style={{
                      marginLeft: 'auto',
                      marginRight: baseline,
                    }}
                  >Currency:
                  </Span>
                <CurrencySelect />
                </>)}
              </div>
            </div>
          )}
        </header>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/blocks/PageHeader/index.tsx